import styled from "@emotion/styled";
import { ScrollArea } from "@mantine/core";

export const ScrollTableWrapper = styled(ScrollArea)`
  width: 100%;
  height: calc(100vh - 104px - 1.5% - 120px);

  .mantine-ScrollArea-thumb {
    background-color: ${({ theme }) => theme.colors.main[9]};
  }

  .mantine-ScrollArea-scrollbar {
    &:hover {
      background-color: initial;
    }
  }
`;

export const ScrollTableHead = styled.thead`
  position: sticky;
  top: -3px;
  width: 100%;
  z-index: 5;
`;

export const ScrollTableBody = styled.tbody`
  width: 100%;
`;
